export default "RCT zu dyadischem Yoga bei Kopf-Hals-Tumoren – Einbeziehung von Angehörigen als Teil der Intervention im Kontext von Chemoradiotherapie."